import { render, staticRenderFns } from "./FullscreenDialog.vue?vue&type=template&id=3d2a81f5&scoped=true"
import script from "./FullscreenDialog.vue?vue&type=script&lang=ts"
export * from "./FullscreenDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a81f5",
  null
  
)

export default component.exports